/**
 * Build-time-constant names for shared `@keyframes` animations defined in keyframesGlobalStyle.
 */
export const keyframes = {
  /** Optional: `--enter-x`, `--enter-y`, `--enter-scale`, `--enter-opacity`. */
  enter: 'mp-enter',
  fade: 'mp-fade',
  /** Optional `--fade-to` (defaults to 1). */
  fadeTo: 'mp-fade-to',
  /** Optional: `--to-x`, `--to-y`, `--to-scale`. */
  translateTo: 'mp-translate-to',

  scaleToHide: 'mp-scale-to-hide',
  scaleToShowAndHide: 'mp-scale-to-show-and-hide',
  scaleIcon: 'mp-scale-icon',
  /** Requires `--ping-color` on the element. */
  ping: 'mp-ping',

  targetC360ToRestingState: 'mp-target-c360-to-resting-state',
  targetC360BagExit: 'mp-target-c360-bag-exit',
  /** Requires `--hero-height` on the element. */
  targetC360HeroHeight: 'mp-target-c360-hero-height',
  targetC360RevealBanner: 'mp-target-c360-reveal-banner',
  /** Requires `--hero-height` on the element. */
  homepageHeroHeight: 'mp-homepage-hero-height',
  /** Requires `--bag-from-x` and `--bag-from-scale`; optional `--bag-mid-x`. */
  homepageBagSequence: 'mp-homepage-bag-sequence',
  /** Optional `--headline-from-bottom` and `--headline-from-right`. */
  homepageSlideInHeadline: 'mp-homepage-slide-in-headline',
  messageRoll: 'mp-message-roll',
  carouselBounce: 'mp-carousel-bounce',
  expand: 'mp-expand',
  collapse: 'mp-collapse',
  slideUp: 'mp-slide-up',
  /** Requires `--shadow-fill` on the element. */
  shadowFill: 'mp-shadow-fill',
} as const
